import React from 'react';
import {
    DesktopOnlyItemWrapper,
    IconBadge,
    IconLink,
    MenuIconWrapper,
    MenuLabel,
    StyledMoodBoardIcon,
} from './IconsButtonTray.styles';
import useTranslator from 'Client/hooks/useTranslator';
import useConfig from 'Client/hooks/useConfig';
import useGa from 'Client/hooks/useGa';
import { TrackHeaderActions } from 'Common/ga/types';
import { usePageResolver } from 'Client/components/ListingPage/hooks/useTrackingPageLabel';
import useFeatureToggle from 'Client/hooks/useFeatureToggle';

export const MoodBoardMenuItem = () => {
    const t = useTranslator();
    const { links } = useConfig();
    const pageTypeLabel = usePageResolver();
    const { interiorServiceInNav } = useFeatureToggle();
    const ga = useGa();

    const menuItem = interiorServiceInNav
        ? {
              label: 'Icon IDS',
              link: links.interiorService,
              trackingEvent: 'interiordesignclick',
              trackingAction: TrackHeaderActions.HeaderInteriorDesignIconClick,
          }
        : {
              label: 'moodboard_desktopheader',
              link: links.moodboardLandingPage,
              trackingEvent: 'moodboardiconclick',
              trackingAction: TrackHeaderActions.HeaderMoodboardIconClick,
          };

    const handleIconClick = () => {
        ga.oneHeader.trackHeaderAction(menuItem.trackingEvent, menuItem.trackingAction, pageTypeLabel);
    };

    const iconBadgeText = t('IDS_NEW_icon').toUpperCase();

    return (
        <DesktopOnlyItemWrapper data-testid="one-header-icon-moodboard" onClick={handleIconClick}>
            <IconLink to={menuItem.link}>
                <MenuIconWrapper>
                    {interiorServiceInNav && <IconBadge>{iconBadgeText}</IconBadge>}
                    <StyledMoodBoardIcon />
                </MenuIconWrapper>
                <MenuLabel>{t(menuItem.label)}</MenuLabel>
            </IconLink>
        </DesktopOnlyItemWrapper>
    );
};
